import script from "./TressAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./TressAccordion.vue?vue&type=style&index=0&id=2b050a84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b050a84"]])

export default __exports__